import createRecursiveFunction from "./createRecursiveFunction.js";
const createRecursiveFunctionForAnalytics = (callback)=>createRecursiveFunction(callback, {
        condition: ()=>window && 'function' == typeof window.ga
    });
const src_createRecursiveFunctionForAnalytics = createRecursiveFunctionForAnalytics;
export default src_createRecursiveFunctionForAnalytics;
